export default __webpack_public_path__ + "static/media/img12.8e397cf5.jpg";